import type { DriverEntity } from '@/features/driver/domain/entities/DriverEntity'
import type { RegionEntity } from '@/features/region/domain/entities/RegionEntity'

export class MissingDriverDocumentFilterEntity {
  driver?: DriverEntity
  region?: RegionEntity
  page?: number
  limit?: number
  sortField?: string
  sortDescending?: boolean
}
